export var getContenidoTipoFuncionAbrirIframe = function getContenidoTipoFuncionAbrirIframe(state, zona) {
  var paramsVinculo = zona.vinculo.split(':')[1];

  var _paramsVinculo$split = paramsVinculo.split('.'),
      carpeta = _paramsVinculo$split[0],
      fichero = _paramsVinculo$split[1],
      paramsIframe = _paramsVinculo$split[2];

  var contenido = {
    tipo: 'funcion,abrirIframe',
    src: 'contenido/' + carpeta + '/' + fichero + '.html' + (paramsIframe ? '?' + paramsIframe : '')
  };
  return contenido;
};